/* eslint-disable @typescript-eslint/no-explicit-any */
// This component handles both internal and external navigation through our site. Using GatsbyLink component, with added support for intls
// This is your Link component
import { PropsWithChildren } from 'react';

import { addTrailingSlash } from '../../utils/url';

import { ExternalLink, InternalLink } from './styles';

// Smooth scroll to jump links
const handleClickToLink = (url: string, event: any) => {
  try {
    // Abort if the link is not a jump link
    if (!/^#/.test(url)) return false;

    // Find the anchor element. Abort if element is not found
    const element = document.querySelector(event.currentTarget.hash.replace(/\/+$/, ''));
    if (!element) return false;

    // Find anchor element position and scroll to it
    const offset = 70; // offset is the height of the header
    const offsetPosition = element.getBoundingClientRect().top - offset;
    window.scrollBy({
      top: offsetPosition,
      behavior: 'smooth',
    });
    event.preventDefault();
    return true;
  } catch (err) {
    console.warn('Link component - could not smooth scroll to element.', err);
    return false;
  }
};
export interface LinkProps {
  href?: string;
  staticResource?: boolean;
  isExternal?: boolean;
  [key: string]: unknown;
}

const Link = ({
  href = '/',
  staticResource = false,
  isExternal = false,
  children,
  ...other
}: PropsWithChildren<LinkProps>) => {
  const isInternal = /^(\/(?!\/)|#)/.test(href);

  if (isInternal && !isExternal && !staticResource) {
    return (
      <InternalLink
        to={addTrailingSlash(href)}
        {...other}
        onClick={(event) => {
          handleClickToLink(href, event);
        }}
      >
        <span>{children}</span>
      </InternalLink>
    );
  }

  const isSpecialLink = /\btel:\b|\bmailto:\b/.test(href);
  const target = isSpecialLink ? '' : '_blank';
  const rel = isSpecialLink ? '' : 'noopener noreferrer';
  return (
    <ExternalLink
      href={href}
      target={target}
      rel={rel}
      {...other}
    >
      <span>{children}</span>
    </ExternalLink>
  );
};

export const Primary = (props: any) => <Link $primary {...props} />;

export const Secondary = (props: any) => <Link $secondary {...props} />;

export const Footer = (props: any) => <Link $footer {...props} $lineHeight="20px" />;

export const Blue = (props: any) => <Link $blue {...props} />;

export const Black = (props: any) => <Link $black {...props} />;

export const Unstyled = (props: any) => <Link $unstyled {...props} />;

export const Menu = (props: any) => (
  <Link {...props} fontSize={{ default: '16px', md: '22px' }} />
);

export const SubMenu = (props: any) => (
  <Link $submenu {...props} fontSize={{ default: '16px', md: '22px' }} />
);

export default Link;
